import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'good' | 'warn' | 'bad' | 'info' | 'cyan' | 'dark';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-line text-ink2',
  good: 'bg-green-bg text-[#0B7A55]',
  warn: 'bg-amber-bg text-[#9A5C07]',
  bad: 'bg-red-bg text-[#B02E38]',
  info: 'bg-blue-bg text-[#2F57C6]',
  cyan: 'bg-cyan-bg text-[#0B7EA0]',
  dark: 'bg-ink text-white',
};

/** The prototype's `.bd`: a small rounded label, optionally with a dot. */
export function Badge({ tone = 'neutral', dot = false, children }: { tone?: BadgeTone; dot?: boolean; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center gap-[5px] whitespace-nowrap rounded-md px-[7px] py-0.5 text-[11.5px] font-semibold ${TONES[tone]}`}>
      {dot ? <i className="h-1.5 w-1.5 rounded-full bg-current" /> : null}
      {children}
    </span>
  );
}
